import React from 'react';
import PropTypes from 'prop-types';
import Header from '../../molecules/Header/Header';
import '../../global.css';

const AppTemplate = ({ children }) => (
  <div className="wrapper">
    <Header />
    <div className="contentWrapper">
      <div className="tableContent shadow">{children}</div>
    </div>
  </div>
);

AppTemplate.propTypes = {
  children: PropTypes.any,
};

export default AppTemplate;
